import './PlayerName.css';
import Button from '../../components/Button/Button';
import { playSound } from '../../utils/utils';

const PlayerName = (props) => {
  const { numberOfPlayers, name, id, handleChange, handleDelete } = props;

  const handleDeletePlayer = (id) => {
    playSound('/sounds/dice-hits-board.mp3');
    handleDelete(id);
  };

  return (
    <div className="playerName" key={id}>
      <input
        key={id}
        className="playerNameInput"
        type="text"
        // value={name}
        onChange={(e) => handleChange(id, e.target.value)}
        maxLength={15}
        placeholder={name}
        required
      />

      {numberOfPlayers > 2 ? (
        <Button
          type="smallSquare delete"
          ariaLabel={`Delete player ${name || id}`}
          handleClick={() => handleDeletePlayer(id)}
        />
      ) : (
        <Button
          type="smallSquare delete"
          disabled={true}
          ariaLabel={`Delete player ${name || id}`}
        />
      )}
    </div>
  );
};

export default PlayerName;
